import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@cieda/djayma-ui";

interface KeyboardShortcutsCheatsheetProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
}

const SHORTCUTS = [
  { keys: ["\u2191", "k"], action: "keyboard.nav_up" },
  { keys: ["\u2193", "j"], action: "keyboard.nav_down" },
  { keys: ["x"], action: "keyboard.toggle_select" },
  { keys: ["Shift", "A"], action: "keyboard.select_all" },
  { keys: ["Esc"], action: "keyboard.clear" },
  { keys: ["e"], action: "keyboard.edit" },
  { keys: ["s"], action: "keyboard.stock_drawer" },
  { keys: ["Cmd", "K"], action: "keyboard.command_palette" },
  { keys: ["Cmd", "F"], action: "keyboard.focus_search" },
  { keys: ["?"], action: "keyboard.show_shortcuts" },
] as const;

/**
 * Cheatsheet dialog listing all keyboard shortcuts for the products page.
 * Triggered by pressing "?".
 */
export function KeyboardShortcutsCheatsheet({
  open,
  onOpenChange,
}: KeyboardShortcutsCheatsheetProps) {
  const { t } = useTranslation("admin");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{t("products.keyboard.cheatsheet_title")}</DialogTitle>
        </DialogHeader>
        <div className="divide-y divide-stone-100">
          {SHORTCUTS.map((shortcut) => (
            <div
              key={shortcut.action}
              className="flex items-center justify-between py-2"
            >
              <span className="text-sm text-stone-600">
                {t(`products.${shortcut.action}`)}
              </span>
              <div className="flex items-center gap-1">
                {shortcut.keys.map((key) => (
                  <kbd
                    key={key}
                    className="inline-flex min-w-[24px] items-center justify-center rounded border border-stone-300 bg-stone-50 px-1.5 py-0.5 text-xs font-medium text-stone-600"
                  >
                    {key}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
